
import { useEffect } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import TestimonialsSection from './components/TestimonialsSection';
import ShopSection from './components/ShopSection';
import AccessSection from './components/AccessSection';
import ReservationSection from './components/ReservationSection';

const HomePage = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        <HeroSection />
        <FeaturesSection />
        <BeforeAfterSection />
        <TestimonialsSection />
        <ShopSection />
        <AccessSection />
        <ReservationSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
